import { CSSProperties } from 'react';
import { GoBackLinkComponent } from '@vivli/shared/components';
import { Size } from '@vivli/shared/theme';
import { useStudyContext } from '@vivli/features/studies/infrastructure/context';
import { StudyWorkflowButtonsComponent } from './study-workflow-buttons.component';
import { useFormContext, useFormState } from 'react-hook-form';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { AdminHeaderView } from '@vivli/shared/views';

const goBackStyle: CSSProperties = {
    justifyContent: 'normal',
    paddingBottom: 5
};

export const AnnotateStudyHeaderComponent = () => {
    const { study, handleFormSave, handleUpdateAndStatusChange } = useStudyContext();
    const formApi = useFormContext<IStudy>();
    const studyInformationPath = `/admin/studies/${study.id}/admin-study-feature`;

    const handleUpdate = (statusObject) => {
        handleUpdateAndStatusChange(statusObject);
    };

    return (
        <>
            <AdminHeaderView style={{ marginBottom: Size.INSET_SIZE / 2, display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <GoBackLinkComponent style={goBackStyle} dataId={DTICommonConst.HeaderApprovalButton('Back')} />
                    </div>
                    <div>
                        <GoBackLinkComponent
                            destination={studyInformationPath}
                            textToShow={`Go to Study Information`}
                            dataId={DTICommonConst.HeaderApprovalButton('GoBackInitial')}
                        />
                    </div>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                    <StudyWorkflowButtonsComponent onSaveClick={() => handleFormSave()} onStatusChange={handleUpdate} />
                </div>
            </AdminHeaderView>
        </>
    );
};
